import { makeStyles } from 'tss-react/mui';

export const useBaseTableStyles = makeStyles({ name: 'BaseTable' })(theme => {
  const isLightTheme = theme.palette.mode === 'light';

  return {
    root: {
      borderRadius: theme.spacing(7.5),
      overflow: 'auto',

      /* TODO: reuse this styles in other scrollable widgets */
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(5, 2, 5, 5),
      backgroundImage: 'none',
      paddingBottom: 0,
      position: 'relative',

      '&:after': {
        content: '""',
        display: 'block',
        position: 'sticky',
        left: 0,
        bottom: 20,
        width: '100%',
        height: 40,
        background: isLightTheme
          ? 'linear-gradient(180deg, rgba(255, 255, 255, 0.04) 0%, #FFF 75%)'
          : 'linear-gradient(180deg, rgba(0, 0, 0, 0.04) 0%, #2E343C 75%)',
      },
    },
    title: {
      paddingRight: theme.spacing(3),
    },
  };
});
